(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DC", [], factory);
	else if(typeof exports === 'object')
		exports["DC"] = factory();
	else
		root["DC"] = factory();
})(this, () => {
return 